"use client";

import { MdClose } from "react-icons/md";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import CheckoutForm from "@/components/payments/checkoutForm";
const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);
const Payment = ({
  paymentData,
  ClosePaymentPopup
}) => {
  const [clientSecret, setClientSecret] = useState(null);
  const finalAmount = paymentData.finalAmount > 10000 ? paymentData.finalAmount : `${paymentData.finalAmount}00`;
  useEffect(() => {
    let isMounted = true;
    const createPaymentIntent = async () => {
      try {
        const response = await fetch("/api/payment-intent", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [{
              finalAmount: finalAmount,
              currency: paymentData?.currency
            }]
          })
        });
        const data = await response.json();
        if (isMounted) setClientSecret(data.clientSecret);
      } catch (error) {
        // console.error("Error fetching clientSecret:", error);
      }
    };
    createPaymentIntent();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentData]);
  const getStripeAppearance = () => {
    const isDark = document.documentElement.classList.contains("dark");
    return {
      theme: isDark ? "night" : "stripe",
      variables: {
        colorPrimary: "#222222",
        // Tailwind Indigo
        colorBackground: isDark ? "#1f2937" : "#ffffff",
        // Tailwind gray-900 or white
        colorText: isDark ? "#dddddd" : "#000000",
        borderRadius: "3px",
        fontFamily: "Inter, sans-serif"
      }
    };
  };
  return <div className="w-screen h-screen fixed top-0 left-0 flex justify-center items-center bg-black/30 z-50">
      <div className="w-full h-auto md:w-2/5 min-h-28 rounded bg-primary-foreground shadow-lg overflow-hidden">
        <div className="flex justify-between items-start p-4">
          <h1 className="font-bold text-primary/75">
            Total Amount: {paymentData.currency} {paymentData.visaPrice}
          </h1>
          <div className="closeIcons flex justify-end">
            <span className="cursor-pointer transition-all duration-300 hover:text-red-600" onClick={ClosePaymentPopup}>
              <MdClose className="text-2xl" />
            </span>
          </div>
        </div>
        <div className="p-4">
          {clientSecret ? <Elements stripe={stripePromise} options={{
          clientSecret,
          appearance: getStripeAppearance()
        }}>
              <CheckoutForm userInfo={paymentData} />
            </Elements> : <h5 className="text-center py-4 text-success font-weight-bold">
              Loading payment details...
            </h5>}
        </div>
      </div>
    </div>;
};
export default Payment;